export const ASPECT_RATIO_COEFFICIENT = 3.3;
export const DATA_TEST_ID = 'header-logo-link';
